import type { ReactNode } from 'react';

/** The shell both signed-out screens sit in, so they cannot drift apart. */
function AuthLayout({
  title,
  subtitle,
  children,
  aside,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
  aside?: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-paper px-5 py-10 text-ink">
      <div className="mx-auto w-full max-w-4xl">
        <p className="mb-8 text-center font-display text-3xl font-extrabold tracking-tight">
          Pun &amp; Done
        </p>

        <div className="flex flex-col gap-6 md:flex-row md:items-start">
          <section className="w-full rounded-2xl border-2 border-ink bg-white px-6 py-7 shadow-pop md:flex-1">
            <h1 className="font-display text-2xl font-bold">{title}</h1>
            <p className="mb-6 mt-1 text-ink/60">{subtitle}</p>
            {children}
          </section>

          {aside && <div className="w-full md:flex-1">{aside}</div>}
        </div>
      </div>
    </div>
  );
}

/**
 * The "or" between social sign-in and the email form.
 *
 * Lives here rather than in each screen so the two cannot drift, and because it
 * only ever means one thing: everything above this line and everything below it
 * reach the same account.
 */
export function Divider() {
  return (
    <div className="my-5 flex items-center gap-3" aria-hidden="true">
      <span className="h-0.5 flex-1 bg-ink/15" />
      <span className="font-display text-xs font-bold uppercase tracking-widest text-ink/40">or</span>
      <span className="h-0.5 flex-1 bg-ink/15" />
    </div>
  );
}

export default AuthLayout;
